const iconColorTokens = [
  'primary',
  'primary-hover',
  'on-primary',
  'secondary',
  'secondary-hover',
  'on-secondary',
  'placeholder',
  'success',
  'on-success',
  'success-hover',
  'warning',
  'on-warning',
  'warning-hover',
  'danger',
  'on-danger',
  'danger-hover',
  'surface',
  'surface-solid',
  'surface-variant',
  'surface-raised',
  'surface-overlay',
  'surface-selected',
  'surface-interactive',
  'surface-interactive-hover',
  'on-surface',
  'on-surface-variant',
  'text-secondary',
  'text-tertiary',
  'border',
  'border-hover',
  'primary-subtle',
  'primary-border',
  'danger-subtle',
  'overlay',
  'border-color',
  'border-light',
  'message-bg'
] as const

export type IconColorToken = (typeof iconColorTokens)[number]

export const iconMaskColorClasses: Record<IconColorToken, string> = Object.fromEntries(
  iconColorTokens.map((token) => [token, `bg-${token}`])
) as Record<IconColorToken, string>

export const iconSlotColorClasses: Record<IconColorToken, string> = Object.fromEntries(
  iconColorTokens.map((token) => [token, `text-${token}`])
) as Record<IconColorToken, string>

export const iconColorKeys = iconColorTokens
